<template>
    <Card :title="$t('labels.custom_fields')">
        <div class="card-body">
            <FormGroup :label="customField.title" v-for="customField in customFields">
                <Input 
                    v-if="customField.type === 'string' || customField.type === 'link'"
                    :model-value="product?.custom_fields[customField.uuid]"
                    @update:model-value="product.custom_fields[customField.uuid] = $event"
                />
                <Input
                    v-if="customField.type === 'number'"
                    :model-value="product?.custom_fields[customField.uuid]"
                    @update:model-value="product.custom_fields[customField.uuid] = $event"
                    type="number"
                />
                <textarea v-if="customField.type === 'longtext'" class="form-control elastic" v-model="product.custom_fields[customField.uuid]"/>
                <Select
                    v-if="customField.type === 'select'"
                    @update:model-value="product.custom_fields[customField.uuid] = $event.value"
                    :model-value="product?.custom_fields[customField.uuid]"
                    :selected-value="product?.custom_fields[customField.uuid]"
                    :options="getOptions(customField.additional.items)"
                    option-key="key"
                    option-value="value"
                />
                <Checkbox v-if="customField.type === 'checkbox'" v-model="product.custom_fields[customField.uuid]" />
                <small v-if="customField.description" class="form-text text-muted">{{ customField.description }}</small>
            </FormGroup>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../../components/new/CardComponent.vue";
import FormGroup from "../../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../../components/new/form/Input.vue";
import Select from "../../../../../components/new/form/select/AppSelect.vue";
import Checkbox from "../../../../../components/new/form/checkbox/AppCheckbox.vue";

import { httpClient } from "../../../../../services/HttpClient";

export default {
    name: "InternalProductCustomFieldsPage",
    components: {
        Card, Input, FormGroup, Select, Checkbox
    },
    props: {
        product: {
            type: Object
        }
    },
    emits: ["update", "count"],
    data() {
        return {
            customFields: []
        }
    },
    methods: {
        fetchCustomFields() {
            httpClient.get(`/projects/${this.$route.params.projectUuid}/pim/custom-fields`, {
                models: ['product-item'],
                limit: 0
            }).then((response) => {
                this.customFields = response.data.data
                this.$emit('count', this.customFields.length)
            })
        },
        getOptions(items) {
            return items.map(item => ({
                key: item,
                value: item
            }))
        },
    },
    mounted() {
        this.fetchCustomFields()
    }
}
</script>